/**
 * HOR-50 / HOR-83: Kategorien des Servicekatalogs (Backend-Enum ArticleCategory).
 *
 * Die Kunden-App gruppiert den Katalog (GET /articles/catalog) nach diesen vier
 * Kategorien, in genau dieser Reihenfolge - sie entspricht den vier frueheren
 * Listen des Anfrage-Wizards. Die Artikelverwaltung sortiert ihre Tabelle nach
 * derselben Reihenfolge, damit der Admin sieht, was der Kunde sieht.
 *
 * Gemeinsame Quelle fuer Reihenfolge, Labels und Sortierung, damit Artikel-
 * verwaltung und Vorgangsansicht nicht auseinanderlaufen.
 */
export const ARTICLE_CATEGORIES = ['general', 'restauration', 'dial', 'optional']

// Uebersetztes Label; unbekannte Werte (z.B. ein neuer Enum-Wert im Backend) werden
// roh angezeigt statt als leerer String zu verschwinden.
export const articleCategoryLabel = category => i18n(`articles.categories.${category}`, { defaultValue: String(category) })

// valueEnum fuer ProTable-Spalten (valueType 'select'). Bei jedem Render aufrufen,
// damit ein Sprachwechsel sofort durchschlaegt.
export const articleCategoryValueEnum = () => Object.fromEntries(ARTICLE_CATEGORIES.map(category => [category, { text: articleCategoryLabel(category) }]))

// Sortier-Rang: bekannte Kategorien in Wizard-Reihenfolge, leer/unbekannt ans Ende
// (entspricht NULLS LAST im Katalog-Endpunkt).
export const articleCategoryRank = category => {
  const index = ARTICLE_CATEGORIES.indexOf(category)

  return index === -1 ? ARTICLE_CATEGORIES.length : index
}

/**
 * Sortierung wie im Kunden-Katalog: Kategorie, dann sortOrder (kleiner zuerst), dann Name.
 * Fehlende/ungueltige sortOrder zaehlen als 0 (DB-Default). Der Namensvergleich ist
 * sprachbewusst und ignoriert Gross-/Kleinschreibung - Postgres sortiert nach seiner
 * Collation, minimale Abweichungen bei Umlauten sind moeglich, aber unkritisch.
 */
export const compareArticlesForCatalog = (a, b) => {
  const byCategory = articleCategoryRank(a?.category) - articleCategoryRank(b?.category)

  if (byCategory !== 0) return byCategory

  const bySortOrder = (Number(a?.sortOrder) || 0) - (Number(b?.sortOrder) || 0)

  if (bySortOrder !== 0) return bySortOrder

  return String(a?.name || '').localeCompare(String(b?.name || ''), 'de', { sensitivity: 'base', numeric: true })
}
